import { observer } from "mobx-react-lite";
import { ContextProps, MenuSite } from "@menu/core/types";
import { Channels, CountryFlagIcon, InboxIcon, ProfileIcon, SignIn, SignOut, SiteLogo } from "@menu/components/shared";
import HeaderLinks from "./header-links";
import SearchIcon from "./search-icon";
import SubNav from "./sub-nav";
import useMenuActions from "../use-menu-actions";
import SiteSwitcher from "./site-switcher";
import { imageUrl } from "@menu/core/lib";
import MenuContext, { DisplayItem } from "@menu/core/menu.context";
import environment from "@menu-environment";
import CartIcon from "../shared/cart-icon";
import WishListIcon from "../shared/wishlist-icon";
import TopNav from "./top-nav";
import AppBanner from "../shared/app-banner";

const getMainSite = (context: MenuContext) => {
  const image = context.mainConfig?.sites[0]?.image 
      ?? imageUrl(environment.menu.mainLogo.image);

  return {
    ...environment.menu.mainLogo,
    image: image,
    link: context.mainSiteUrl
  } as MenuSite
}

const DesktopNav = observer((props: ContextProps) => {
  const { context } = props;

  const { isMainSite, isMobile, site, config } = context;

  const { showSearch, selectHeaderLink } = useMenuActions(context);

  const isNewMenu = config.useGraphicalMenu;

  if (isMobile) {
    return null;
  }

  let extraCss = "";

  //Non DStv sites have less space due to the icon on the right
  const numberOfNavItems = context.site.navItems?.length ?? 0;
  if (context.siteName !== "" && numberOfNavItems > 6) {
    const linkText = context.site.navItems?.map((x) => x?.title ?? "").join(" ");
    const length = linkText?.length ?? 0;

    if (length > 50) {
      extraCss = " x-condensed";
    } else if (length > 37) {
      extraCss = " condensed";
    }
  }

  const mainSite = isMainSite ? context.site : getMainSite(context);

  extraCss = isNewMenu ? extraCss + " updated-header-menu" : extraCss;

  const clickFlag = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    const itemToDisplay = context.displayChannelMenu ? DisplayItem.MainNav : DisplayItem.Channels;
    context.updateDisplayItem(itemToDisplay);
  }

  const { dynamicHeaderSpacing, showAppBanner } = context.config;

  const useDynamicSpacing = showAppBanner || !!dynamicHeaderSpacing;
  const dynamicSpacing = useDynamicSpacing ? "dynamic": "";
  const cssClassName = context.selectedArea ? "" : "top-menu-shadow";

  //TODO: use context provider rather than using ContextProps
  return (
    <nav id="top-menu" className={`${cssClassName} ${dynamicSpacing}`}>
      {isNewMenu && <TopNav context={context} />}
      <nav className="header-menu">
        <div className={`header-menu-container${extraCss}`}>
          <span className="main-links">
            <SiteLogo site={site} />

            {isMainSite && <SiteSwitcher context={context} />}

            <HeaderLinks onSelect={selectHeaderLink} context={context} />
          </span>

          <span className="icons">
            {!isMainSite && <SiteSwitcher context={context} />}

            {!isMainSite && (<SiteLogo site={mainSite} className="main-logo" spanWrap={false} /> )}

            <SearchIcon showSearch={showSearch} />

            <CountryFlagIcon context={context} countryCode={context.countryCode} onClick={clickFlag} />

            <InboxIcon context={context} />

            <CartIcon context={context} />

            <WishListIcon context={context} />

            <ProfileIcon context={context} />

            <SignIn context={context} />

            <SignOut context={context} />
          </span>
        </div>
      </nav>

      <SubNav context={context} />

      <Channels context={context} />

      <AppBanner context={context} />
    </nav>);
});

export default DesktopNav;